(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-search"] && !Shopify.designMode) return;
  try {
    
  // Handle predictive search visibility
  document.addEventListener('DOMContentLoaded', function() {
    const searchComponents = document.querySelectorAll('.predictive-search--inline');

    searchComponents.forEach(component => {
      const searchInput = component.querySelector('.search-input');

      if (searchInput) {
        // Monitor input changes
        searchInput.addEventListener('input', function() {
          if (this.value.trim().length > 0) {
            component.setAttribute('data-has-query', '');
          } else {
            component.removeAttribute('data-has-query');
          }
        });

        // Also check on focus
        searchInput.addEventListener('focus', function() {
          if (this.value.trim().length === 0) {
            component.removeAttribute('data-has-query');
          }
        });

        // Hide results when clicking outside
        document.addEventListener('click', function(e) {
          if (!component.contains(e.target)) {
            component.removeAttribute('data-has-query');
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
